/**
 * Change the page size for logged out category page to 56 tiles per page. * https:www.notion.so/faire/H2-2024-Increase-product-tile-count-on-all-Categories-eae2659186bd472a90c37fa824c103d3
 */
export const ENABLE_LARGER_PAGE_SIZE_ON_LOGGED_OUT_CATEGORY_240718 = 'ENABLE_LARGER_PAGE_SIZE_ON_LOGGED_OUT_CATEGORY_240718';
